import { FC, memo } from "react"

interface TableListCellProps {
    children?: React.ReactNode
    className?: string
    isLabel?: boolean
    hideBelowMd?: boolean
    hideBelowLg?: boolean
    direction?: 'vertical' | 'horizontal'
    justifyContent?: 'start' | 'end' | 'center' | 'between' | 'around' | 'evenly'
}

const TableListCell: FC<TableListCellProps> = ({ children, className, isLabel = false, hideBelowMd = false, hideBelowLg = false, direction = 'horizontal', justifyContent = 'start', ...props }) => {
    const getJustifyClass = (justify: string) => {
        const justifyMap = {
            start: 'justify-start',
            end: 'justify-end',
            center: 'justify-center',
            between: 'justify-between',
            around: 'justify-around',
            evenly: 'justify-evenly'
        }
        return justifyMap[justify as keyof typeof justifyMap] || 'justify-start'
    }

    return (
        <div className={`${hideBelowLg ? "hidden lg:table-cell" : hideBelowMd ? "hidden md:table-cell" : "table-cell"} table-fixed px-2 lg:px-3 align-middle text-gray-800 ${className ?? ""} ${isLabel ? "bg-gray-50 font-semibold text-gray-700" : "py-1 lg:py-2"}`} {...props}>
            <div className={`flex w-auto min-w-0 items-center ${direction === `horizontal` ? `gap-x-2 flex-cel` : `flex-col items-start`} ${getJustifyClass(justifyContent)} [&>svg>fill-black]:h-6 [&>svg]:w-6 [&>svg]:fill-black`}>
                {children}
            </div>
        </div>
    )
}

export default memo(TableListCell)

